export * from './weeklyList';
